import {BaseCachedService} from './Core/BaseCachedService';

class SurveyQuestionSecondaryFieldRequiredService extends BaseCachedService {
    get Url() { return super.Url + "/surveyQuestionSecondaryFieldRequireds"; }
    get ModelName() { return "Survey Question Secondary Field Required Type"; }
    get PrimaryKeyProperty() { return "surveyQuestionSecondaryFieldRequiredId"; }
}

export const service = new SurveyQuestionSecondaryFieldRequiredService();


